<template>
  <div id="driver-lookup">
    <v-card class="card-style">
      <v-form :model="form" id="form">
        <v-row>
          <v-col md="6" offset-md-3>
            <v-text-field
              id="dvlaNumber"
              v-model="form.dvlaNumber"
              label="DVLA Number"
              outlined>
            </v-text-field>
          </v-col>
          <v-col md="6" offset-md-3>
            <v-text-field
              id="pcoNumber"
              v-model="form.pcoNumber"
              label="PCO Number"
              outlined>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="driver.data !== undefined">
          <v-card class="card-style mb-6">
            <v-card-title>Driver Details</v-card-title>
            <v-divider class="mx-4"></v-divider>
            <div>
              <v-chip class="ma-6" color="#2F3B74" text-color="white">
                <v-icon left>mdi-account-circle-outline</v-icon>
                {{driver.data.first_name}} {{driver.data.last_name}}
              </v-chip>
            </div>
            <v-spacer></v-spacer>
          </v-card>
        </v-row>
        <v-row class="button-style">
          <v-col v-if="driver.data !== undefined">
            <div>
              <v-btn
                id="btn-approve"
                :disabled="driverId !== ''"
                rounded
                @click="setDriverToStore"
                color="primary"
                :dark="driverId == ''"
                style="margin-right: 1em"
              >Approve</v-btn>
              <v-btn
                id="btn-discard"
                color="#ef3340"
                @click="clearForm"
                dark
                rounded
              >Discard</v-btn>
            </div>
          </v-col>
          <v-col v-else>
            <v-btn color="primary" dark rounded @click="lookupDriver">Search</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: { dvlaNumber: '', pcoNumber: '' },
      driver: false,
      baseUrl: process.env.VUE_APP_ENV_VARIABLE,
    };
  },
  async created() {
    const path = this.$route.query;
    if (Object.keys(path).includes('pco', 'dvla')) this.getDriver(path.dvla, path.pco);
  },
  mounted() {
    this.$root.$on('clearForm', () => {
      this.clearForm();
    });
  },
  methods: {
    async lookupDriver() {
      const { dvlaNumber, pcoNumber } = this.form;
      if (dvlaNumber !== '' && pcoNumber !== '') {
        this.getDriver(dvlaNumber, pcoNumber);
      } else {
        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'Please make sure to fill dvla and pco fields.',
        });
      }
    },
    async getDriver(dvla, pco) {
      try {
        this.driver = await axios.get(
          `${this.baseUrl}/theory-lookup?dvla=${dvla}&pco=${pco}`,
        );
        this.form.dvlaNumber = dvla;
        this.form.pcoNumber = pco;
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'There is no valid assessment with these details.',
        });
      }
    },
    async setDriverToStore() {
      const assessmentId = this.driver.data.assessment_id;
      const driverId = this.driver.data.driver_id;
      const { dvlaNumber, pcoNumber } = this.form;
      const args = {
        assessmentId,
        driverId,
        pcoNumber,
        dvlaNumber,
      };
      await this.$store.dispatch('theory/setDriverDetails', args);
    },
    clearForm() {
      this.form = {};
      this.resetStore();
      this.driver = false;
    },
    resetStore() {
      this.$store.dispatch('theory/resetStore');
    },
  },
  beforeDestroy() {
    this.resetStore();
  },
  computed: {
    driverId() {
      return this.$store.getters['theory/getDriverId'];
    },
  },
};
</script>
<style lang="scss">
.container {
  display: inline;
}
#driver-lookup {
  margin-top: 2.2em;
}
#form {
  padding: 1em 1em 0 1em;
}
.v-input__control {
  flex-direction: column-reverse;
}
.card-style {
  border-radius: 20px !important;
  width: 100%;
}
.button-style {
  float: right;
}
.v-card__title {
  font-size: 1rem;
  font-weight: 400;
}
.v-chip.v-size--default {
  border-radius: 16px !important;
}
</style>
